/*
 *  Licensed under the EUPL, Version 1.2 or – as soon they will be approved by
 * the European Commission - subsequent versions of the EUPL (the "Licence");
 * You may not use this work except in compliance with the Licence.
 * You may obtain a copy of the Licence at:
 *
 *  https://joinup.ec.europa.eu/software/page/eupl
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the Licence is distributed on an "AS IS" basis,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the Licence for the specific language governing permissions and
 * limitations under the Licence. */

import { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { getTagsByName } from "../../../../actions/TiamatActions.modern";
import { useAppDispatch } from "../../../../store/hooks";

export interface UseReportTagsResult {
  availableTags: Array<{ name: string; comment?: string }>;
  loadAvailableTags: () => void;
}

export const useReportTags = (): UseReportTagsResult => {
  const dispatch = useAppDispatch();
  const { locale } = useIntl();
  const [availableTags, setAvailableTags] = useState<
    Array<{ name: string; comment?: string }>
  >([]);

  const loadAvailableTags = useCallback(() => {
    const sortByName = (a: { name: string }, b: { name: string }) =>
      a.name.localeCompare(b.name, locale);
    dispatch(getTagsByName("")).then(({ data }: any) => {
      setAvailableTags(data.tags ? data.tags.slice().sort(sortByName) : []);
    });
  }, [dispatch, locale]);

  return { availableTags, loadAvailableTags };
};
